import { PolicyPage } from '../components/PolicyRenderer'
import { termsContent } from './termsContent'
import PageMeta from '../components/PageMeta'

export default function TermsConditions() {
    return <>
        <PageMeta
            title="Terms and Conditions"
            description="Contract Finder Pro terms and conditions. The terms governing your use of the platform and advisory services."
            canonical="/terms"
        />
        <PolicyPage content={termsContent} />
    </>
}
